import { useDispatch, useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import { useLocation, useNavigate } from 'react-router';
import { getApplications, selectAccounts } from '../../store/actions/authActions';
import { setApplicantType, setClientApplicationId, setKsaCorporate, setRejectionMsg } from '../../store/slices/constantSlice';
import { createCorpApplication, generateAuthToken } from '../../store/actions/corporateAction';
import { useEffect } from 'react';
import { getContentKeyAccToLang } from '../../utils/utils';
import { setUserData } from '../../store/slices/commonSlice';
export default () => {
  const { isArabic, TextWeight, direction } = dynamicfunction();

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const { auth_content } = useSelector((state) => state.common);
  const { applications, authLoading, applications_loading } = useSelector((state) => state.auth);
  const { nafath_loading } = useSelector((state) => state.corporate);
  const { is_corporate, is_ksa_corporate } = useSelector((state) => state.constant);
  const { authContent, language } = useSelector((state) => state.content);
  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_open_new_account?.data?.attributes, key, isArabic);
  };

  const user = location.state?.data;

  const onPressApplication = (item) => {
    dispatch(setClientApplicationId(item?.applicationId));
    dispatch(setRejectionMsg(item?.rejectionReason ?? null));

    const api_data = {
      targetClientId: item?.clientId,
      investorTypeId: item?.investorTypeId,
      languageId: user?.clientLanguage?.languageId,
    }
    dispatch(selectAccounts(api_data, (res) => {
      navigate('/funds/available-funds');
    }))
  };

  return {
    isArabic,
    direction,
    TextWeight,
    applications,
    authLoading,
    onPressApplication,
    user,
    getContentKey,
  };
};
